import config from '../../../config'

import emitter from '../../../emitter'

import {

	DEBUG

} from 'constants'

import {

	ShaderMaterial,

	Vector3,

	Color,

	Vector2

} from 'three'

let colors = {

	colorA: 0x5200ff,
	colorB: 0x0000ff,
	lightcolorA: 0x5200ff,
	lightcolorB: 0x0000ff,
}

let raycastDecay = 0.09

export default class Material extends ShaderMaterial { 

	constructor(){

		let opts = 

			{
				uniforms: {

					resolution: {

						type:'v2',value: new Vector2(1,1)
					},
					aspect: {

						type:'f',value: 1
					},

					timer: {

						type:'f', value: 0
					},

					absTimer:{

						type:'f', value: 0
					},
					alpha: {

						type:'f', value: 0
					},

					amplitude: {

						type:'f', value: 1.3
					},

					amplitude2: {

						type:'f', value: -0.95
					},

					frequency: {

						type:'f', value: 5.9
					},

					frequency2: {

						type:'f', value: 10.7
					},

					colorA: {

						type:'c', value: new Color(colors.colorA)
					},

					colorB: {

						type:'c', value: new Color(colors.colorB)
					},

					lightcolorA: {

						type:'c', value: new Color(colors.colorA)
					},

					lightcolorB: {

						type:'c', value: new Color(colors.colorB)
					},
					lightLength: {

						type:'f', value:1
					},

					lightSpeed:{

						type:'f', value: 1000
					},

					lightMin:{

						type:'f', value: 0
					},

					lightMax:{

						type:'f', value: 1
					},

					raycasted: {

						type:'f', value: 0.5
					},

					raycastPower: {

						type:'f',

						value: 0
					},

					raycastAmplitude:{

						type:"f",
						value: 0.05
					},

					raycastEffect: {

						type:"f",
						value: 0.11
					}



				},
				
				vertexShader: require('./shader/vert.glsl'),

				fragmentShader: require('./shader/frag.glsl'),

				transparent: true,

				side: 2

			}
		

		super(opts)

		opts.vertexShader   = require('./shader/occlusion.vert.glsl')
		opts.fragmentShader = require('./shader/occlusion.frag.glsl')

		this.occlusionMaterial = new ShaderMaterial(opts)

		opts.fragmentShader = require('./shader/picking.glsl')
		this.pickingMaterial = new ShaderMaterial(opts)

		this.lightSpeedValue = 1
		this.globalSpeed = 1

		this.sens = 0

		this.addEvents()

	}

	resize(w,h){

		this.uniforms.resolution.value.set(w,h)
		this.uniforms.aspect.value = w / h

	}

	update(delta){


		this.uniforms.timer.value += delta * this.globalSpeed
		this.uniforms.absTimer.value += delta

		this.uniforms.lightSpeed.value += delta * this.lightSpeedValue * this.globalSpeed

	}

	set alpha(val){

		this.uniforms.alpha.value = val
	}

	get alpha(){

		return this.uniforms.alpha.value
	}

	setTriggerLight(a, b){

		this.uniforms.lightSpeed.value = 0

		this.uniforms.lightcolorA.value.copy( this.uniforms.colorA.value )

		this.uniforms.lightcolorB.value.copy( this.uniforms.colorB.value )

		this.uniforms.colorA.value.setHex( a ) 

		this.uniforms.colorB.value.setHex( b ) 
	}

	onRaycasted(e){

		
		if(this.tween){

			this.tween.kill()
		}
		if(this.tween2){

			this.tween2.kill()
		}

		this.tween = TweenLite.to(this.uniforms.raycasted, Math.abs(this.uniforms.raycasted.value - e) * 1.5 , {

			value: e
		})

		this.tween2 = TweenLite.to(this.uniforms.raycastPower, 0.2 * 0.8, {

			value: 1,
			ease: Expo.easeOut,
			onComplete:()=>{

				// this.uniforms.raycastPower.value = 0
				 TweenLite.to(this.uniforms.raycastPower, 1.3 * 0.8, {
				 	ease: Elastic.easeOut.config(1, 0.25),
				 	value: 0
				 })
			}
		})
	
		this.sens = 1
	}


	addEvents(){

		emitter.on('resize', this.resize.bind(this))
		emitter.on('colorA', (val)=> { this.uniforms.colorA.value.setHex(val); colors.colorA = val })
		emitter.on('colorB', (val)=> { this.uniforms.colorB.value.setHex(val); colors.colorB = val })
		emitter.on('lightcolorA', (val)=> { this.uniforms.lightcolorA.value.setHex(val); colors.lightcolorA = val })
		emitter.on('lightcolorB', (val)=> { this.uniforms.lightcolorB.value.setHex(val); colors.lightcolorB = val })
		emitter.on('frequency', (val)=> { this.uniforms.frequency.value = val })
		emitter.on('frequency2', (val)=> { this.uniforms.frequency2.value = val })
		emitter.on('amplitude', (val)=> { this.uniforms.amplitude.value = val })
		emitter.on('amplitude2', (val)=> { this.uniforms.amplitude2.value = val })
		emitter.on('lightLength', (val)=> { this.uniforms.lightLength.value = val })
		emitter.on('lightSpeed', (val)=> { this.lightSpeedValue = val; })
		emitter.on('globalSpeed', (val)=> { this.globalSpeed = val })
		emitter.on('triggerLight', (a, b)=> { this.setTriggerLight(a, b) })
		emitter.on('bounceAmplitude', (val)=> { this.uniforms.raycastAmplitude.value = val })
		emitter.on('bounceRange', (val)=> { this.uniforms.raycastEffect.value = val; })

		emitter.on('raycasted', this.onRaycasted.bind(this))
		// trail.colorA = 0x2ce5c4
		// trail.colorB = 0xf400dc
		// trail.lightcolorA = 0xc915b7
		// trail.lightcolorB = 0xff000f
		
		// trail.frequency = 5.9 
		// trail.frequency2 = 11 
		// trail.amplitude = 1.3
		// trail.amplitude2 = -0.95
		// trail.lightLength = 0.1 
		// trail.lightSpeed = 1.8 
		// trail.globalSpeed = 0.5 
	}

	easeInOutElastic(t) {
	 return (.04 - .04 / t) * Math.sin(25 * t) + 1
	}

	removeGUI(){

		gui.removeFolder(this._folder)
	}

}



// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/trail/material/index.js